import React from 'react'
import { Icon, Spin } from 'antd'

export const Spinner = () => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '75vh' }}>
            <Spin indicator={<Icon type="loading" style={{ fontSize: 24, color: "#15808C" }} spin />} />
        </div>
    )
}

